import React from 'react';

const PLACEHOLDER = /(\[[A-Z /&]+\])/;
const IS_PLACEHOLDER = /^\[[A-Z /&]+\]$/;

const withPlaceholders = (text) =>
  text.split(PLACEHOLDER).map((part, i) =>
    IS_PLACEHOLDER.test(part) ? (
      <mark key={i} className="bg-amber-100 text-amber-900 rounded px-1 font-semibold" title="To be completed by The OnCall Bot LLC">
        {part}
      </mark>
    ) : (
      part
    )
  );

export const BaaDocument = ({ text }) => {
  const lines = (text || '').split('\n');
  const out = [];
  let list = [];
  const flush = () => {
    if (list.length) out.push(<ul key={`ul${out.length}`} className="list-disc pl-6 my-2 space-y-1">{list}</ul>);
    list = [];
  };
  lines.forEach((l, i) => {
    if (l.startsWith('- ')) return list.push(<li key={i}>{withPlaceholders(l.slice(2))}</li>);
    flush();
    if (l.startsWith('### ')) out.push(<h4 key={i} className="font-semibold text-slate-900 mt-4 mb-1">{l.slice(4)}</h4>);
    else if (l.startsWith('## ')) out.push(<h3 key={i} className="font-bold text-slate-900 text-base mt-6 mb-2 tracking-wide">{l.slice(3)}</h3>);
    else if (l.startsWith('# ')) out.push(<h2 key={i} className="font-extrabold text-slate-900 text-xl text-center mb-2 tracking-wider">{l.slice(2)}</h2>);
    else if (l.trim()) out.push(<p key={i} className="my-2">{withPlaceholders(l)}</p>);
  });
  flush();
  return (
    <div data-testid="baa-document" className="text-[13.5px] leading-relaxed text-slate-700 font-serif">
      {out}
    </div>
  );
};
